<template>
  <footer class="footer">
    <p> © _Cover by CodeBreaker</p>
  </footer>
</template>

<script>
export default {
  name: 'CoverFooter',
};
</script>

<style>
.footer {
  padding-block: 1rem;
  font-size: 0.875rem;
  text-align: center;
}
</style>
